
const restrictedDomains = ['gmail.com', 'yahoo.com', 'hotmail.com', 'aol.com', 'hotmail.co.uk', 'hotmail.fr', 'msn.com']

export const isRestrictedDomain = (email: string) => {
    const domain = email.split('@')[1];
    return restrictedDomains.includes(domain);
  }

export const emailWarning = "Personal email address is not permitted, Please provide a company email address"